import { render } from "./IconBikeFast.vue?vue&type=template&id=7b04a70a"
import script from "./IconBikeFast.vue?vue&type=script&lang=js"
export * from "./IconBikeFast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__